import React, { useState, useEffect } from 'react'
import { Text, Stack, Flex, Collapse, Box, ThemeIcon, ActionIcon, Divider, Code, Button } from "@mantine/core"
import { useDisclosure } from '@mantine/hooks';
import styled from "styled-components";

import { IconBrandMeta, IconBrandGoogleFilled, IconTrash, IconChevronDown, IconChevronUp } from '@tabler/icons-react'
import actionList from './actionList'
import logos from './Logos'
import sendGtmEvent from '@util/sendGtmEvent';
import sendMetaPixelEvent from '@util/sendMetaPixelEvent';

const Logo = styled.img`
  width: 32px;
  height: 32px;
  object-fit: contain;
`;

const providerOptions = [
  { label: "Meta Pixel", value: "meta_pixel", icon: <IconBrandMeta size={16} /> },
  { label: "GTM", value: "gtm", icon: <IconBrandGoogleFilled size={16} /> },
]

export default function EventList({ events = [], setEvents = () => { } }) {
  const [filters, setFilters] = useState({
    provider: "",
  });

  // useEffect(() => {
  //   setFilters({ ...filters, provider: "" });
  // }, [events]);

  const filteredEvents = events.filter(item => filters.provider === "" ? true : item.provider === filters.provider);
  const providerFilters = providerOptions.filter(item => events.some(event => event.provider === item.value));


  return (
    <div>
      <Flex gap="xs" mb="sm">
        <Text fw={600}>Events ({filteredEvents.length})</Text>
        {providerFilters.length > 1 && providerFilters.map((item) => (
          <ActionIcon key={item.value} color="blue" size="md" radius="xl" variant={item.value === filters.provider ? "filled" : "light"} onClick={() => setFilters({ ...filters, provider: item.value === filters.provider ? "" : item.value })}>
            {item.icon}
          </ActionIcon>
        ))}
      </Flex>
      <Stack gap="xs">
        {filteredEvents.map((item, index) => (
          <div key={item.id}>
            {index !== 0 && <Divider opacity={0.8} pt="sm" />}
            <Item item={item} onDelete={() => {
              if (filteredEvents.filter(m => m.id !== item.id).length === 0) {
                setFilters({ ...filters, provider: "" });
              }
              setEvents(events.filter(m => m.id !== item.id));
            }} />
          </div>
        ))}
        {filteredEvents.length === 0 && <Text size="sm" c="dimmed">No events found</Text>}
      </Stack>
    </div>
  )
}

const Item = ({ item, onDelete }) => {
  const action = actionList.find(m => m.id === item.action_id);
  const [opened, { toggle }] = useDisclosure(false);
  if (!action) return null;

  return (
    <div>
      <Flex gap="md" align="start">
        <Logo src={logos[item.provider]} />
        <Stack gap="xs" style={{ flex: 1 }}>
          <div>
            <Text size="sm" fw={600}>{action.name}</Text>
            {/* <Text size="sm">{action.description}</Text> */}
            {item.created_at && <Text size="xs" c="dimmed">event added {new Date(item.created_at).toLocaleString()}</Text>}
            <Collapse in={opened} mt="md">
              {item.description && <Text size="sm" mb="lg">{item.description}</Text>}
              <Box mb="lg">
                <Text size="xs" fw={600} mb="xs">What'll be sent</Text>
                <Code block size="sm" styles={{
                  root: {
                    textWrap: "wrap",
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                    overflowWrap: "break-word",
                    wordWrap: "break-word",
                  }
                }}>{formatWhatWillBeSent(item)}</Code>
              </Box>
              <Text size="xs" fw={600} mb="xs">Provided Snippet</Text>
              <Code block size="sm" styles={{
                root: {
                  textWrap: "wrap",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                  overflowWrap: "break-word",
                  wordWrap: "break-word",
                  wordBreak: "break-word",
                  overflowWrap: "break-word",
                  wordWrap: "break-word",
                  wordBreak: "break-word",
                }
              }}>{item.snippet}</Code>
              <Text size="xs" fw={600} mt="lg" mb="xs">About this action</Text>
              <Box p="xs" style={{
                borderRadius: "var(--mantine-radius-md)",
                border: "1px solid var(--mantine-color-gray-3)",
                backgroundColor: "var(--mantine-color-yellow-0)",
                maxWidth: "100%",
              }}>
                <Text size="xs">{action.description}</Text>
              </Box>
              <Button mt="lg" size="xs" radius="lg" variant="light" onClick={() => {
                if (item.provider === "gtm") {
                  sendGtmEvent(item.event_category, item.event_action, item.event_value);
                } else if (item.provider === "meta_pixel") {
                  sendMetaPixelEvent(item.event_category, item.event_action, item.event_value);
                } else {
                  console.warn("Unknown provider");
                }
              }}>Test this event</Button>
              <Flex justify="end" mt="lg">
                <ActionIcon color="gray" variant="light" size="xs" radius="xl" onClick={() => onDelete(item.id)}>
                  <IconTrash size={12} />
                </ActionIcon>
              </Flex>
            </Collapse>
          </div>
        </Stack>
        <ActionIcon color="gray" size="sm" radius="xl" variant="light" onClick={toggle}>
          {opened ? <IconChevronUp /> : <IconChevronDown />}
        </ActionIcon>
      </Flex>
    </div>
  )
}

function formatWhatWillBeSent(item) {
  return `${item.provider === "meta_pixel" ? "fbq" : "gtag"}('${item.event_category}', '${item.event_action}'${JSON.stringify(item.event_value) !== "{}" ? `, ${JSON.stringify(item.event_value)}` : ""})`
}